module.exports = __webpack_public_path__ + "img/zhengdi.7546b47e.jpg";